export const routes = Object.freeze({
  home: '/',
  donate: '/:username',
})
